/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBrandLocationsRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetBrandLocationsResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getBrandLocations = (request: GetBrandLocationsRequest, options?: CashRequestOptions) => post<GetBrandLocationsRequest, GetBrandLocationsResponse>("/cash-app/local/get-brand-locations", request, {...options, rejectOnError: true })